/** Shared chart visualization types for Add chart + ChartRenderer. */

export const CHART_VIZ_OPTIONS = [
    { value: 'table', label: 'Table' },
    { value: 'stat', label: 'Count card' },
    { value: 'bar', label: 'Bar' },
    { value: 'bar_horizontal', label: 'Bar (horizontal)' },
    { value: 'stacked_bar', label: 'Stacked bar' },
    { value: 'line', label: 'Line' },
    { value: 'area', label: 'Area' },
    { value: 'pie', label: 'Pie' },
    { value: 'donut', label: 'Donut' },
    { value: 'treemap', label: 'Tree map' },
    { value: 'scatter', label: 'Scatter' },
    { value: 'radar', label: 'Radar' },
];

export const SINGLE_METRIC_VIZ = new Set(['pie', 'donut', 'treemap', 'radar', 'stat']);

export const STAT_VIZ = 'stat';

/** Viz types that use period + record_count (time on x-axis). */
export const TIME_SERIES_VIZ = new Set(['line', 'area', 'scatter']);

/** True when the category axis represents dates/periods (zoom should focus on latest). */
export function isTimeSeriesChart(vizType, catCol, catColumn) {
    if (TIME_SERIES_VIZ.has(vizType)) return true;
    if (catCol === 'period') return true;
    if (catColumn?.type === 'datetime') return true;
    const key = String(catCol ?? '').toLowerCase();
    return /date|period|month|week|time|day|year/.test(key);
}

export function normalizeVolumeEncoding(value) {
    if (!value) return [];
    return Array.isArray(value) ? value.filter(Boolean) : [value];
}

export function encodingHasVolume(encoding) {
    const vols = normalizeVolumeEncoding(encoding?.value);
    return vols.length > 0;
}
